import React from 'react';
import { Link } from 'react-router-dom';
import siteConfig from '../../config/site.config';
import { PRIVATE_ROUTE } from '../../route.constants';
import logo from '../../assets/images/app-icon.png';
import logoSecondario from '../../assets/images/logo_secondario.png';

export default ({ collapsed }) => {
  return (
    <div className="isoLogoWrapper">
      {collapsed ? (
        <div
          style={{
            display: 'flex',
            height: '100%',
            alignItems: 'center',
            justifyContent: 'center',
          }}
        >
          <Link to={PRIVATE_ROUTE.DASHBOARD}>
            <img src={logo} alt="logo" style={{ width: '70%' }} />
          </Link>
        </div>
      ) : (
        <h3>
          <Link to={PRIVATE_ROUTE.DASHBOARD}>
            <img
              src={logoSecondario}
              alt="logo secondario"
              style={{ width: '100%' }}
            />
          </Link>
        </h3>
      )}
    </div>
  );
};
